/* ===========================================================================
   Empurra botoes flutuantes (WhatsApp e afins) para cima quando a barra fixa
   de compra aparece.

   Por que por JS e nao por CSS: esses botoes sao injetados pelo app depois
   do carregamento, com classes que mudam a cada versao. Em vez de perseguir
   o seletor de um app especifico, procuramos no proprio DOM quem se comporta
   como botao flutuante — fixo, ancorado embaixo e estreito.

   Nao mexe em nada alem do "bottom", e devolve o valor original quando a
   barra some.
   =========================================================================== */
(function () {
  var FOLGA = 12;

  function ehWidgetFlutuante(el, barra) {
    if (el === barra || el.contains(barra) || barra.contains(el)) return false;
    if (el.tagName === 'SCRIPT' || el.tagName === 'STYLE') return false;
    var cs = window.getComputedStyle(el);
    if (cs.position !== 'fixed') return false;
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;

    var b = parseFloat(cs.bottom);
    /* ancorado no rodape: widget colado embaixo, nao painel de tela cheia */
    if (isNaN(b) || b > 140) return false;

    var r = el.getBoundingClientRect();
    if (!r.width || !r.height) return false;
    /* barra larga nao e botao flutuante — evita empurrar a propria faixa
       de compra de outro app, ou um banner de cookies                    */
    if (r.width > window.innerWidth * 0.6) return false;
    if (r.height > 220) return false;
    return true;
  }

  function init() {
    var barra = document.querySelector('sticky-add-cart');
    if (!barra) return;

    var guardados = [];

    function subir() {
      var altura = barra.getBoundingClientRect().height || 0;
      if (!altura) return;
      [].slice.call(document.body.children).forEach(function (el) {
        if (!ehWidgetFlutuante(el, barra)) return;
        if (el.dataset.psEmpurrado === '1') return;
        var orig = window.getComputedStyle(el).bottom;
        el.dataset.psEmpurrado = '1';
        guardados.push({ el: el, bottom: el.style.bottom });
        el.style.transition = 'bottom .25s ease';
        el.style.bottom = parseFloat(orig || 0) + altura + FOLGA + 'px';
      });
    }

    function descer() {
      guardados.forEach(function (g) {
        g.el.style.bottom = g.bottom;
        delete g.el.dataset.psEmpurrado;
      });
      guardados = [];
    }

    function conferir() {
      barra.classList.contains('show-sticky-cart') ? subir() : descer();
    }

    new MutationObserver(conferir).observe(barra, {
      attributes: true,
      attributeFilter: ['class'],
    });
    /* o widget costuma entrar depois da pagina; uma segunda passada pega
       quem chegou atrasado */
    setTimeout(conferir, 1500);
    setTimeout(conferir, 4000);
    window.addEventListener('resize', conferir);
    conferir();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
